import { render, staticRenderFns } from "./ClerkSubmit.vue?vue&type=template&id=7b8590a8&scoped=true&"
import script from "./ClerkSubmit.vue?vue&type=script&lang=js&"
export * from "./ClerkSubmit.vue?vue&type=script&lang=js&"
import style0 from "./ClerkSubmit.vue?vue&type=style&index=0&id=7b8590a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8590a8",
  null
  
)

export default component.exports